export enum PaymentMethodEnum {
  WIRE_TRANSFER = 'wire-transfer',
  BANK_DRAFT = 'bank-draft',
}

export interface SupplierModel {
  id: number;
  name: string;
  vat_number: string;
  email: string;
  phone: string;
  state: string;
  payment_method?: PaymentMethodEnum;
  max_payment_days?: number;
  special_payment_due_date?: number;
  is_non_payer?: boolean;
  total_discounts: number;
  discount_on: 'order' | 'order_line';
  discount_mode: 'absolute' | 'relative';
  created_at?: string;
  contasol_id?: string;
}
